export default __webpack_public_path__ + "static/media/check-icon.e6dd23b1.svg";